import styled from 'styled-components';
import {
  themeGet,
  space,
  SpaceProps,
  flex,
  FlexProps,
  width,
  WidthProps,
  height,
  HeightProps,
  borders,
  BordersProps,
  borderRadius,
  BorderRadiusProps,
  borderColor,
  color,
  fontSize,
  fontWeight,
  letterSpacing,
  lineHeight,
  textAlign
} from 'styled-system';
import { CheckCircle } from 'styled-icons/fa-solid/CheckCircle';
import { basicTheme } from 'src/theme';
import { controlStyle, controlSize, disabledStyles, errorsStyles } from './styles';

const getInputHeight = themeGet('heights.input');
const primaryButtonColor = themeGet('colors.greenBlue');
const errorColor = themeGet('colors.error');

export type BaseStyledInputProps = StyledSystemProps<
  'input',
  {
    variant?: keyof typeof basicTheme.inputs;
    size?: keyof typeof basicTheme.controlSizes;
    error?: boolean;
  }
>;

export const BaseStyledInput = styled.input.attrs(props => ({
  value: props.value || ''
}))<BaseStyledInputProps>`
  appearance: none !important;
  display: block;
  width: 100%;
  font-family: ${themeGet('fonts.base')};
  border-width: 1px;
  border-style: solid;
  outline: none;
  resize: none;
  font-size: 14px;

  &:disabled {
    ${disabledStyles};
  }

  &::placeholder {
    color: ${themeGet('colors.placeholder')};
  }

  ${controlStyle};
  ${controlSize};
  ${errorsStyles}
`;

export type StyledInputProps = BaseStyledInputProps &
  SpaceProps &
  FlexProps &
  WidthProps &
  HeightProps &
  BordersProps &
  BorderRadiusProps & {
    color?: string;
    bg?: string;
  };

export const StyledInput = styled(BaseStyledInput)<StyledInputProps>`
  ${space};
  ${flex};
  ${width};
  ${height};
  ${borders};
  ${borderRadius};
  ${borderColor};
  ${color};
  ${fontSize};
  ${fontWeight};
  ${letterSpacing};
  ${lineHeight};
  ${textAlign};
`;

StyledInput.defaultProps = {
  variant: 'primary',
  size: 'md'
};

export const ValideIcon = styled(CheckCircle)`
  position: absolute;
  top: ${props => (getInputHeight(props) - props.size) / 2}px;
  right: 10px;
  border-radius: 50%;
  color: ${props => primaryButtonColor(props)};
  background-color: #fff;
`;

export const StyledError = styled.div`
  margin-top: 10px;
  color: ${errorColor};
  font-size: 12px;
  &:first-letter {
    text-transform: uppercase;
  }
`;
